import { FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { FlexProps } from '@chakra-ui/react';
import {
    ExternalFinancialEntity,
    ExternalFinancialEntityType,
    getDefaultName,
} from '@common/financialEntities';
import { feConfigs } from '@common/financialEntities/config';
import { Button } from '../common/Button';
import BasicModalLayout from '../common/modals/BasicModalLayout';
import ManualAddForm from './ManualAddForm';

export interface ManualAddViewProps extends FlexProps {
    type: ExternalFinancialEntityType;
    nextButtonText: string;
    onComplete: (fe: ExternalFinancialEntity) => Promise<void>;
    onConnectAccount: () => void;
    onCancel: () => void;
}

const ManualAddView = ({
    onComplete,
    onConnectAccount,
    onCancel,
    type,
    nextButtonText,
    ...props
}: ManualAddViewProps) => {
    const config = feConfigs[type];
    const isLinkable = config.isLinkable;
    const name = getDefaultName(type);

    return (
        <BasicModalLayout
            title={
                <FlexRow gap={3} align="center">
                    <Icon name={config.iconName} size="lg" />
                    {name}
                </FlexRow>
            }
            subtitle={
                isLinkable && (
                    <>
                        You can add any account without{' '}
                        <Button
                            variant="link"
                            onClick={onConnectAccount}
                            onClickEvent="Manual Add Connect Account Button Clicked"
                        >
                            connecting it
                        </Button>
                        , but you’ll need to update the balance yourself.
                    </>
                )
            }
            content={
                <ManualAddForm
                    key={type}
                    type={type}
                    nextButtonText={nextButtonText}
                    onComplete={onComplete}
                    onCancel={onCancel}
                />
            }
            {...props}
        />
    );
};

export default ManualAddView;
